import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as ExcelJS from 'exceljs';
import { FileService } from './file.service';
import { FileTypeEnum } from 'app/API.service';
import { ESE_ENUM } from './enums/ese.enum';
import { SortDirectionEnum } from './enums/sort-direction.enum';
import { CUSTOMAPIService } from 'app/custom-api.service';
import { saveAs } from 'file-saver';
import { from, Observable, of, Subject } from 'rxjs';
import JSZip from 'jszip';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class ESEService {
  questions: any = [];
  validationErrors: { [rowIndex: number]: { [key: string]: boolean } } = {};
  failedRows: any = [];
  isDataValidated: boolean = true;
  selectedQuestion: any = [];
  headerItemsESE = [
    {
      name: 'Question Num',
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '8vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.FUNCTION,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '6vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.CATEGORY,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '7vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.SUB_CATEGORY,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '8vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.CONTROL_NAME,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '8vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.CONTROL_LABEL,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '8vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.QUESTION,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '22.2vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.REMEDIATION_TASK,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '21.5vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.SUPPLEMETED_GUIDE,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '12vw',
      isGroup: false,
    },
    {
      name: ESE_ENUM.SEVERITY,
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '6vw',
      isGroup: false,
    },
    {
      name: 'Mandatory',
      svgName: '',
      isSortApplicable: true,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '14vw',
      isGroup: true,
      children: [
        {
          name: 'Artifacts',
          isSortApplicable: true,
          width: '6.9vw',
          sortDirection: SortDirectionEnum.ASCENDING,
        },
        {
          name: 'Comments',
          isSortApplicable: true,
          width: '7vw',
          sortDirection: SortDirectionEnum.ASCENDING,
        },
      ],
    },
    {
      name: 'Template',
      svgName: '',
      isSortApplicable: false,
      isSortApplied: false,
      sortDirection: SortDirectionEnum.ASCENDING,
      width: '5vw',
      isGroup: false,
    },
  ];
  initialQuestionObject: any = {
    [ESE_ENUM.QUESTION_NUMBER]: 1,
    [ESE_ENUM.FUNCTION]: '',
    [ESE_ENUM.CATEGORY]: '',
    [ESE_ENUM.SUB_CATEGORY]: '',
    [ESE_ENUM.CONTROL_NAME]: '',
    [ESE_ENUM.CONTROL_LABEL]: '',
    [ESE_ENUM.QUESTION]: '',
    [ESE_ENUM.REMEDIATION_TASK]: '',
    [ESE_ENUM.SUPPLEMETED_GUIDE]: '',
    [ESE_ENUM.SEVERITY]: 'Critical',
    [ESE_ENUM.MANDATORY_ARTIFACTS]: 'True',
    [ESE_ENUM.MANDATORY_COMMENTS]: 'True',
    [ESE_ENUM.TEMPLATE]: '',
    [ESE_ENUM.IS_SELECTED]: false,
    [ESE_ENUM.TEMPLATE_FILE]: [],
  };
  /**
   * No need to add Template File key in this object because that thing is verified via ESE_ENUM.TEMPLATE
   */
  initialErrorObject: { [key: string]: boolean } = {
    [ESE_ENUM.QUESTION_NUMBER]: false,
    [ESE_ENUM.FUNCTION]: false,
    [ESE_ENUM.CATEGORY]: false,
    [ESE_ENUM.SUB_CATEGORY]: false,
    [ESE_ENUM.CONTROL_LABEL]: false,
    [ESE_ENUM.CONTROL_NAME]: false,
    [ESE_ENUM.QUESTION]: false,
    [ESE_ENUM.REMEDIATION_TASK]: false,
    [ESE_ENUM.SUPPLEMETED_GUIDE]: false,
    [ESE_ENUM.SEVERITY]: false,
    [ESE_ENUM.MANDATORY_ARTIFACTS]: false,
    [ESE_ENUM.MANDATORY_COMMENTS]: false,
    [ESE_ENUM.TEMPLATE]: false,
    [ESE_ENUM.IS_SELECTED]: false,
  };
  /**
   * No need to add Template File key in this object because that thing is verified via 'template'
   */
  keysObject: any = {
    questionNumber: ESE_ENUM.QUESTION_NUMBER,
    function: ESE_ENUM.FUNCTION,
    category: ESE_ENUM.CATEGORY,
    subCategory: ESE_ENUM.SUB_CATEGORY,
    controlName: ESE_ENUM.CONTROL_NAME,
    controlLabel: ESE_ENUM.CONTROL_LABEL,
    question: ESE_ENUM.QUESTION,
    remediationTask: ESE_ENUM.REMEDIATION_TASK,
    supplementedGuide: ESE_ENUM.SUPPLEMETED_GUIDE,
    severity: ESE_ENUM.SEVERITY,
    mandatoryArtifacts: ESE_ENUM.MANDATORY_ARTIFACTS,
    mandatoryComments: ESE_ENUM.MANDATORY_COMMENTS,
    template: ESE_ENUM.TEMPLATE,
    isSelected: ESE_ENUM.IS_SELECTED,
    templateFile: ESE_ENUM.TEMPLATE_FILE,
  };
  private addRowSubject = new Subject<void>();
  addRow$ = this.addRowSubject.asObservable();
  entity: any = null;
  selectedVendors: any = [];
  currentUser: any = null;
  cachedQuestions: any = [];
  requiredColumns = [
    this.keysObject.mandatoryArtifacts,
    this.keysObject.mandatoryComments,
    this.keysObject.questionNumber,
    this.keysObject.function,
    this.keysObject.category,
    this.keysObject.subCategory,
    this.keysObject.controlName,
    this.keysObject.controlLabel,
    this.keysObject.question,
    this.keysObject.remediationTask,
    this.keysObject.supplementedGuide,
    this.keysObject.severity,
  ];
  constructor(
    private toaster: ToastrService,
    private route: ActivatedRoute,
    private fileService: FileService,
    private customAPi: CUSTOMAPIService
  ) {}

  private _eventName: string = '';
  private _dueDate: number | null = null;

  // Getter and Setter for eventName
  get eventName(): string {
    return this._eventName;
  }

  set eventName(name: string) {
    this._eventName = name;
  }

  // Getter and Setter for dueDate
  get dueDate(): number | null {
    return this._dueDate;
  }

  set dueDate(date: number | null) {
    this._dueDate = date;
  }
  async initComponent(entityId, entity): Promise<void> {
    /**
     * Check any template exist against the rootEntity
     * if(yes) --> so read data and parse it
     * if(no) --> do nothing
     */
    this.questions = [];
    if (entity && entity.isESETemplate) {
      const file = await this.getFrameworkFromS3(entityId, entity); // waits for this to finish
      if (file) {
        await this.parseXLSX(file);
        this.cachedQuestions = JSON.parse(JSON.stringify(this.questions));
      }
    }
  }
  async getFrameworkFromS3(entityId, entity): Promise<any> {
    try {
      const filePath = `${FileTypeEnum.ESE_TEMPLATES}/${entityId}/${entity.isESETemplate}`;
      return await this.fileService.getTextFileFromS3(filePath, {
        download: true,
        level: 'public',
      });
    } catch (err) {
      console.log('ERR: getFrameworkFromS3 - :', err);
      return null;
    }
  }
  capitalizeFirstLetter(str) {
    if (!str) {
      return '';
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  async parseXLSX(arrayBuffer: ArrayBuffer) {
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);

    const worksheet = workbook.worksheets[0];
    if (!worksheet) {
      this.questions = [];
      return;
    }

    // Extract headers from the first row
    const headerRow = worksheet.getRow(1);
    const headerValues = Array.isArray(headerRow.values) ? headerRow.values : [];
    const headers = headerValues.slice(1).map(h => (typeof h === 'string' ? h.trim() : ''));

    // Convert worksheet to array of objects (like sheet_to_json with defval: '')
    const rows: any[] = [];
    worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
      if (rowNumber === 1) {
        return;
      } // skip header
      const rowObj: any = {};
      headers.forEach((header, idx) => {
        // Use '' as default value for empty cells
        let cellVal = row.getCell(idx + 1).value;
        if (cellVal === undefined || cellVal === null) {
          cellVal = '';
        }
        rowObj[header] = cellVal;
      });
      rows.push(rowObj);
    });

    if (!rows.length) {
      this.questions = [];
      return;
    }

    // Step 1: Remove columns with empty headers
    const allKeys = Object.keys(rows[0]).filter(key => key.trim() !== '');
    const missingColumns = this.requiredColumns.filter(col => !allKeys.includes(col));
    if (missingColumns.length) {
      alert(`The uploaded file is missing required column(s): ${missingColumns.join(', ')}`);
      this.questions = [];
      return;
    }

    // Step 2: Remove columns that are empty in all rows
    const nonEmptyColumns = allKeys.filter(key => rows.some(row => row[key] !== ''));

    // Step 3: Clean rows by retaining only non-empty columns
    const cleanedRows = rows.map(row => {
      const cleanedRow: any = {};
      nonEmptyColumns.forEach(key => {
        cleanedRow[key] = row[key];
      });
      return cleanedRow;
    });

    this.questions = [];

    // Step 4: Normalize fields and populate this.questions
    cleanedRows.forEach(r => {
      r[this.keysObject.template] = r[this.keysObject.template] || '';

      const mandatoryArtifacts = r[this.keysObject.mandatoryArtifacts];
      r[this.keysObject.mandatoryArtifacts] =
        mandatoryArtifacts === true || mandatoryArtifacts === false
          ? this.capitalizeFirstLetter(mandatoryArtifacts.toString())
          : this.capitalizeFirstLetter(mandatoryArtifacts || '');

      const mandatoryComments = r[this.keysObject.mandatoryComments];
      r[this.keysObject.mandatoryComments] =
        mandatoryComments === true || mandatoryComments === false
          ? this.capitalizeFirstLetter(mandatoryComments.toString())
          : this.capitalizeFirstLetter(mandatoryComments || '');

      this.questions.push(r);
    });
  }

  addQuestion(questions): {
    questions: any[];
  } {
    this.questions = questions;
    const newRowIndex = this.questions.length;
    const newQuestion = JSON.parse(JSON.stringify(this.initialQuestionObject));
    newQuestion[this.keysObject.questionNumber] = newRowIndex + 1;
    this.questions.push(newQuestion);
    return {
      questions: this.questions,
    };
  }
  updateQuestion(event): {
    questions: any[];
    validationErrors: { [rowIndex: number]: { [key: string]: boolean } };
  } {
    const { value, key, index } = event;
    // validate the column Value
    this.questions[index][key] = value;
    // this.columnValidation(index, key);
    return {
      questions: this.questions,
      validationErrors: this.validationErrors,
    };
  }
  async uploadTemplateToS3(entityId, entity, questions, fileName = ''): Promise<void> {
    try {
      this.questions = JSON.parse(JSON.stringify(questions));
      const blob = await this.fileService.JSONToExcelConversion(this.questions);
      const fileParams = {
        body: blob,
        fileType: FileTypeEnum.ESE_TEMPLATES,
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        url: `${FileTypeEnum.ESE_TEMPLATES}/${entityId}/${fileName}`, // fix extension typo
      };
      await this.fileService.uploadToS3(fileParams, false);
      await this.customAPi.UpdateEntity({ id: entityId, isESETemplate: fileName });
    } catch (err) {
      console.log('Error in uploading file');
    }
  }
  onSave(questions) {
    this.questions = questions;
    this.cachedQuestions = JSON.parse(JSON.stringify(this.questions));
  }
  /**
   * Template against each question
   */
  async uploadArtifactTemplate(entityId: string, entity: any, questions: any[]): Promise<void> {
    try {
      for (const q of questions) {
        const files = q[ESE_ENUM.TEMPLATE_FILE] || [];

        if (files?.length > 0) {
          const zip = new JSZip();

          // Add all files of this question to its own zip
          for (const file of files) {
            if (file) {
              zip.file(file.name, file);
            }
          }

          // Skip if no valid file
          if (Object.keys(zip.files).length === 0) {
            continue;
          }

          // Generate zip
          const zipFile = await zip.generateAsync({ type: 'blob' });

          // Custom filename for this question
          const customZipName = `${entityId}_${Date.now()}`;

          const fileParams = {
            body: zipFile,
            fileType: FileTypeEnum.ESE_TEMPLATES,
            url: `${FileTypeEnum.ARTIFACT_TEMPLATES}/${FileTypeEnum.ESE_ARTIFACT}/${entityId}/${customZipName}.zip`,
            contentType: 'application/zip',
          };

          // Upload single zip per question
          await this.fileService.uploadToS3(fileParams, false);

          q[ESE_ENUM.TEMPLATE] = customZipName;
        }
      }
    } catch (err) {
      console.error('Error while uploading artifacts', err);
    }
  }

  async onComplete(entityId: string, entity: any, questions: any[], fileName): Promise<void> {
    await this.fileService.deleteFolderFromS3(`public/${FileTypeEnum.ESE_TEMPLATES}/${entityId}}`);
    await this.uploadTemplateToS3(entityId, entity, questions, fileName);
  }

  onDelete() {
    this.onSave(this.questions);
  }

  async onDownload(): Promise<void> {
    const fileUrl = await this.fileService.downloadFileFromS3(
      `${FileTypeEnum.ESE_TEMPLATES}/${FileTypeEnum.ESE_TEMP}.xlsx`
    );
    if (fileUrl) {
      const file = await fetch(fileUrl);
      if (file.status === 200) {
        const blob = await file.blob();
        saveAs(blob, `${FileTypeEnum.ESE_TEMP}.xlsx`);
      }
    }
  }

  formatVendors(selectedVendors: { name: string }[]): string {
    if (!selectedVendors || selectedVendors.length === 0) {
      return '';
    }

    if (selectedVendors.length <= 3) {
      return selectedVendors.map(vendor => `"${vendor.name}"`).join(', ');
    } else {
      return `${selectedVendors.length} vendors`;
    }
  }
  async downloadFile(questions) {
    const file = await this.fileService.JSONToExcelConversion(questions);
    const url = window.URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'ESE_Template.xlsx'; // filename
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  formattedFailedRows(rows): string {
    if (!rows || !Array.isArray(rows)) {
      return '';
    }
    return '#' + rows.map(num => num + 1).join(',');
  }
}
